var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.job.type?.name === 'hire_delivery' || _vm.job.type?.name === 'hire_collection'
  )?_c('span',[_vm._v("\n  "+_vm._s(_vm._f("date")(_vm.job.jobable?.vehicle?.start_date))+"\n  "),(_vm.job.jobable?.vehicle?.start_date)?_c('span',[(_vm.job.jobable?.vehicle?.end_date)?_c('span',[_vm._v("to "+_vm._s(_vm._f("date")(_vm.job.jobable?.vehicle?.end_date)))]):_c('span',[_vm._v("to Ongoing")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }